module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    staticClass: "fmh",
    attrs: {
      "id": "epi"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/9780062652874_Contents#repi"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_viii",
      "title": "viii"
    }
  }, [_vm._v("Epigraph")])])]), _vm._v(" "), _c('p', {
    staticClass: "poem_split"
  }, [_c('i', [_vm._v("Far above the crown of stars,")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('i', [_vm._v("there lay a kingdom cast in shadows")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('i', [_vm._v("until a daughter born of light")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('i', [_vm._v("drove the night away.")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('i', [_vm._v("And so the Great Dark waited")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('i', [_vm._v("a thousand turns around the sun")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('i', [_vm._v("and promised on its heart of iron")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('i', [_vm._v("to once again return.")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("—“Origin of the Moon Goddess,”")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('i', [_vm._v("The Cantos of Light")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5efd048d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062652874_Epigrph.vue
// module id = 63
// module chunks = 0